import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './main';

import './fonts/nourishe/NourisheInline.ttf';
import { AzureAD } from 'react-aad-msal';
import App1 from './App';
import { authProvider } from './authProvider';
//console.log(__dirname)
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

